/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsMarkAsStarredRequest,
  TChatsMarkAsStarredModel,
  IMappers,
  TChatsMarkAsStarredResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IMarkAsStarredResponse } from '../../../entities/mark_as_starred/MarkAsStarredResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createChatsMarkAsStarredModel(parameters: TChatsMarkAsStarredRequest): TChatsMarkAsStarredModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/mark-as-starred/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsMarkAsStarredOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsMarkAsStarredRequest;
}

export async function fetchChatsMarkAsStarred<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsMarkAsStarredOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsMarkAsStarredResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsMarkAsStarredModel(parameters),
    config,
  )) as FetchResponse<TChatsMarkAsStarredResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMarkAsStarredResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsMarkAsStarredResponse>;
}
